'use client';

import { useTransitioningCtxState } from '@/components/TransitioningContext/TransitioningContext';
import { Button, ButtonProps } from '@/lib/mx-asurion-ui-react';

type Props = ButtonProps & {
  formName: string;
};
export function FormSubmitButton({
  formName,
  children,
  ...buttonProps
}: Props) {
  const { transitioning, disabled } = useTransitioningCtxState();

  return (
    <Button
      {...buttonProps}
      isLoading={transitioning}
      form={formName}
      type="submit"
      disabled={disabled}
    >
      {children}
    </Button>
  );
}
